import React, { Component } from 'react'
import { connect } from 'react-redux'

import ModalEventsInfo from '../components/Events/ModalEventsInfo'
import ModalAlert from 'components/ModalAlert'
import Pagination from 'components/Pagination'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES } from 'utils/consts'
import { changeVisibillityModalAlert } from 'utils/helpers'

import actions from 'store/actions'

export class Events extends Component {
  constructor() {
    super()

    this.changeVisibillityModalAlert = changeVisibillityModalAlert.bind(this)
  }

  state = {
    event: {},
    modalTitle: '',
    modalText: '',

    pageNumber: SETTINGS_PAGINATION.PAGE_NUMBER,

    isOpenModalEventsInfo: false,
    isOpenModalAlert: false,
    isDisabledUnloadButton: true,
  }

  componentDidMount() {
    document.title = 'СКУД - События'
    this.fetchData(this.state.pageNumber)
  }

  fetchData = async pageNumber => {
    try {
      await this.props.fetchEvents(pageNumber)
    } catch (error) {
      this.changeVisibillityModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }
  }

  /**
   *
   * @param {Object} event
   */
  changeVisibilityModalEventsInfo = async (event = {}) => {
    try {
      if (event.employee_id) {
        this.userInfo = await this.props.fetchDetailByID({
          entityType: 'employee',
          entityID: event.employee_id,
        })
      } else {
        this.userInfo = {}
      }
    } catch (error) {
      this.changeVisibillityModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    }

    this.setState(prevState => ({
      isOpenModalEventsInfo: !prevState.isOpenModalEventsInfo,
      event,
    }))
  }

  /**
   * @param {Number} timestamp
   * @return {String}
   */
  changeFormatDate = timestamp => {
    return new Intl.DateTimeFormat('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',

      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }).format(timestamp * 1000)
  }

  /**
   * @param {Number} id
   * @return {String}
   */
  getEventTypeByID = id => {
    switch (id) {
      case 10:
        return 'INFO'
      case 20:
        return 'WARNING'
      case 30:
        return 'ERROR'
      case 40:
        return 'SYSTEM'
      default:
        return 'UNKNOWN CODE'
    }
  }

  /**
   * @param {Number} count
   * @param {Number} page
   */
  handleChangePagination = (count, page) => {
    const { pageNumber } = this.state

    if (page !== pageNumber) {
      this.fetchData(page)
      this.setState({ pageNumber: page })
    }
  }

  /**
   * @param {Object} e
   */
  changeUnloadingDate = e => {
    this[e.target.name] = e.target.value
    if (this.startDate && this.endDate) {
      this.setState({ isDisabledUnloadButton: false })
    }
  }

  /**
   * @param {String} date
   */
  changeFormatDateApi(date) {
    return `${new Date(date).getFullYear()}-${
      new Date(date).getMonth() < 9
        ? `0${new Date(date).getMonth() + 1}`
        : new Date(date).getMonth() + 1
    }-${
      new Date(date).getDate() <= 9
        ? `0${new Date(date).getDate()}`
        : new Date(date).getDate()
    }`
  }

  getUnloading = async () => {
    const data = {
      start_date: this.changeFormatDateApi(this.startDate),
      end_date: this.changeFormatDateApi(this.endDate),
    }

    try {
      this.setState({ isDisabledUnloadButton: true })
      const response = await this.props.fetchUnloadingByEvents(data)
      this.downloadFile(response, 'file.xls', 'application/vnd.ms-excel')
    } catch (error) {
      this.changeVisibillityModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
    } finally {
      this.setState({ isDisabledUnloadButton: false })
    }
  }

  /**
   *  Преобразуем данные и имитируем нажатие на новую ссылку для скачивания файла
   *  (в Safari скачивание по клику не происходит, файл нужно сохранят в ручную).
   *  @param {ArrayBuffer} data Бинарные данные.
   *  @param {String} fileName Название скачиваемого файла в ОС (в Safari задаваемое название игнорируется,
   *                            будет установлено название `unknown`).
   *  @param {String} mimeType MIME тип
   */
  downloadFile = (data, fileName, mimeType) => {
    let blob = new Blob([data], {type: mimeType || 'application/octet-stream'})
    let blobURL = window.URL.createObjectURL(blob)
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = blobURL
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  render() {
    const {
        event,
        modalTitle,
        modalText,

        isOpenModalEventsInfo,
        isOpenModalAlert,
        isDisabledUnloadButton,
      } = this.state,
      events = this.props.events.events || []

    return (
      <>
        {events.length ? (
          <>
            <div className='top-controls'>
              <div className='wrapper-controls'>
                <input
                  className='input'
                  type='date'
                  name='startDate'
                  onChange={this.changeUnloadingDate}
                />
                <input
                  className='input'
                  type='date'
                  name='endDate'
                  onChange={this.changeUnloadingDate}
                />
                <div className='btn-group'>
                  <button
                    className='btn btn--lg btn--primary'
                    onClick={this.getUnloading}
                    disabled={isDisabledUnloadButton}>
                    Выгрузить отчет
                  </button>
                </div>
              </div>
            </div>
            <div className='table-wrapper'>
              <table className='table'>
                <thead>
                  <tr>
                    <td>Дата и время</td>
                    <td>Объект</td>
                    <td>Тип</td>
                    <td>Комментарий</td>
                  </tr>
                </thead>
                <tbody>
                  {events.map(event => (
                    <tr
                      onClick={() =>
                        this.changeVisibilityModalEventsInfo(event)
                      }
                      key={event.id}>
                      <td>{this.changeFormatDate(event.date)}</td>
                      <td>
                        {!event.access_object_title
                          ? 'Объект не указан'
                          : event.access_object_title}
                      </td>
                      <td>{this.getEventTypeByID(event.type)}</td>
                      <td>{event.comment}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <Pagination
              items={events}
              pageCount={this.props.events.page_count}
              changePagination={this.handleChangePagination}
              isHideControls={true}
            />
          </>
        ) : (
          <div className='not-found'>
            <p>По вашему запросу ничего не найдено.</p>
          </div>
        )}

        {isOpenModalEventsInfo && (
          <ModalEventsInfo
            title='Добавление точки доступа к сотруднику'
            closeModal={this.changeVisibilityModalEventsInfo}
            place={
              !event.access_object_title
                ? 'Объект не указан'
                : event.access_object_title
            }
            date={this.changeFormatDate(event.date)}
            type={this.getEventTypeByID(event.type)}
            userInfo={this.userInfo}
            screens={event.photo}
            comment={event.comment}
          />
        )}

        {isOpenModalAlert && (
          <ModalAlert
            modalTitle={modalTitle}
            modalText={modalText}
            closeModal={this.changeVisibillityModalAlert}
          />
        )}
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    events: state.eventsInfo,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchEvents: page => dispatch(actions.events.fetchEvents(page)),
    fetchDetailByID: data => dispatch(actions.fetchDetailByID(data)),
    fetchUnloadingByEvents: data =>
      dispatch(actions.events.fetchUnloadingByEvents(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Events)
